export default function (phases = []) {
  const sortedPhases = [];
  if (phases.includes("DRESSAGE")) sortedPhases.push("DRESSAGE");
  if (phases.includes("MARATHON")) sortedPhases.push("MARATHON");
  if (phases.includes("CONES")) sortedPhases.push("CONES");
  return sortedPhases;
}
